export default __webpack_public_path__ + "static/media/faqicon5.d61d7cb8.svg";